// Helper function to extract all keys from nested object
export const extractAllKeysFromObject = (obj: any, prefix = ""): string[] => {
  let keys: string[] = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const fullKey = prefix ? `${prefix}.${key}` : key;
      keys.push(fullKey);

      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !Array.isArray(obj[key])
      ) {
        // Recursively get keys from nested objects
        keys = keys.concat(extractAllKeysFromObject(obj[key], fullKey));
      } else if (
        Array.isArray(obj[key]) &&
        obj[key].length > 0 &&
        typeof obj[key][0] === "object"
      ) {
        // Handle arrays of objects - use index notation
        keys.push(`${fullKey}[0]`);
        // You can add more indices if needed, or recursively process array items
        if (obj[key][0]) {
          keys = keys.concat(
            extractAllKeysFromObject(obj[key][0], `${fullKey}[0]`)
          );
        }
      }
    }
  }

  return keys;
};

// Filter out unwanted keys or format them as needed
export const getUpsellDataKeys = (upsellData: any): string[] => {
  if (!upsellData) return [];

  const allKeys = extractAllKeysFromObject(upsellData);

  // Filter out keys you don't want to show, or format them
  return allKeys.filter((key) => {
    // Exclude keys that are not useful for templates
    const excludedKeys = [
      "uuid",
      "id",
      "ts",
      "insert_ts",
      "create_ts",
      "attachments",
      "file",
      "path",
      "extras",
      "service",
    ];
    return !excludedKeys.some((excluded) =>
      key.toLowerCase().includes(excluded.toLowerCase())
    );
  });
};
